// extracted by mini-css-extract-plugin
module.exports = {"shopify-shopping-cart":"ShopifyShoppingCart_shopify-shopping-cart___c73L"};